import {Injectable} from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Observable} from "rxjs";
import {TypeUtils} from "../utils/type-utils";
import {Config} from "../../config/config";

@Injectable()
export class FormDataInterceptor implements HttpInterceptor {

  constructor() {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const hasFile = TypeUtils.isObject(request.body) && !!Object.values(request.body).find((value: any) => TypeUtils.isFile(value));

    if (request.url.includes(Config.lxdEndpoint) || request.url.includes(Config.authEndpoint) || request.url.includes(Config.optimizerEndpoint) || request.url.includes(Config.aiBuilderEndpoint) || request.url.includes(Config.vibeCodingEndpoint) || request.url.includes(Config.miniProductsEndpoint) || request.url.includes(Config.miniToolsEndpoint)) {
      request = hasFile ? this.convertToFormDataRequest(request) : request;
    } else if (request.url.includes(Config.wordpressEndpoint)) {
      request = request;
    } else if (['post', 'put', 'patch'].indexOf(request.method.toLowerCase()) !== -1 && !this._isEcommerceEndpoint(request) &&
        !this._isOutlineHandler(request) &&
        !this._isGodaddyDomain(request) &&
        !this._isResellerClientPackage(request)) {
      request = hasFile ? this.convertToFormDataRequest(request) : this.convertToFormUrlEncodedRequest(request);
    }

    if (request.url.includes(Config.woocomEndpoint) || request.url.includes('navigation/actions') || this._isOutlineHandler(request) || this._isGodaddyDomain(request) || request.url.includes(Config.vibeCodingEndpoint)) {
      delete request.body.service_key;
    }


    return next.handle(request);
  }

  private convertToFormUrlEncodedRequest(request: HttpRequest<any>): HttpRequest<any> {
    let data: string;

    if (TypeUtils.isObject(request.body)) {
      const dataParts: string[] = [];
      Object.keys(request.body).forEach((key: string): void => {
        let value: any = request.body[key];
        if (value === null) {
          value = '';
        } else if (TypeUtils.isObject(value)) {
          value = JSON.stringify(value);
        }

        dataParts.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
      });

      data = dataParts.join('&').replace(/%20/g, '+');
    } else {
      data = ((request.body === null) ? '' : request.body.toString());
    }

    return request.clone({
      body: data,
      setHeaders: {
        'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'
      }
    });
  }

  private convertToFormDataRequest(request: HttpRequest<any>): HttpRequest<any> {
    let data: any;

    if (TypeUtils.isObject(request.body)) {
      let formData: FormData = new FormData();
      for (const key in request.body) {
        if (!request.body.hasOwnProperty(key)) {
          continue;
        }

        let value: any = request.body[key];
        if (value === null) {
          formData.append(key, '');
        } else if (TypeUtils.isFile(value)) {
          formData.append(key, value);
        } else if (TypeUtils.isArray(value)) {
          <Array<any>>value.forEach((item: any): void => {
            formData.append(key, JSON.stringify(item));
          });
        } else if (TypeUtils.isObject(value)) {
          formData.append(key, JSON.stringify(value));
        } else {
          formData.append(key, value);
        }
      }

      data = formData;
    } else {
      data = ((request.body === null) ? '' : request.body.toString());
    }

    return request.clone({
      body: data
    });
  }

  private _isEcommerceEndpoint(request: HttpRequest<any>): boolean {
    return request.url.includes(Config.woocomEndpoint) ||
      request.url.includes('endpoint=settings') ||
      request.url.includes('endpoint=update_product') ||
      request.url.includes('navigation/actions') ||
      request.url.includes('endpoint=products');
  }

  private _isOutlineHandler(request: HttpRequest<any>): boolean {
    return request.url.includes('ai/outline_styles') ||
      request.url.includes('/styles') ||
      request.url.includes('section_types') ||
      request.url.includes('colors_modify') ||
      request.url.includes('build_secondary_page') ||
      request.url.includes('pages_meta') ||
      request.url.includes('colors_modify') ||
      request.url.includes('secondary_page_outline') ||
      request.url.includes('pages_types') ||
      request.url.includes('template_from_outline') ||
      request.url.includes('build_site_from_outline') ||
      request.url.includes('test/outline_styles') ||
      request.url.includes('mini-tools') ||
        request.url.includes('sts-credentials/')
        || request.url.includes('/outline');
  }

  private _isGodaddyDomain(request: HttpRequest<any>): boolean {
    return request.url.includes('/domain-names');
  }

  private _isResellerClientPackage(request: HttpRequest<any>): boolean {
    return request.url.includes('/reseller/client-package');
  }

}
